<template>
  <div>

    <div
      id="map"
      ref="map"
      :style="'background: blue;height: ' + heightCard"
      class="map"/>
    <div
      id="popup"
      class="ol-popup">
      <a
        id="popup-closer"
        href="#"
        class="ol-popup-closer"/>
      <div id="popup-content"/>
    </div>
    <div
      v-if="users !== null && users.length > 0"
      style="max-height: 400px; overflow:auto;">
      <v-btn @click="exportar('csv')">{{ strings[idioma].exporta_csv }}</v-btn>
      <v-btn @click="exportar('pdf')">{{ strings[idioma].exporta_pdf }}</v-btn>
      <table
        border="1"
        class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>EMAIL</th>
            <th>Cidade</th>
            <th>Estado</th>
            <th>Pais</th>
            <th>Telefone</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(user, i) in users"
            :key="i">
            <td><a
              href="javascript:void()"
              @click="open(user)">{{ user.id }}</a></td>
            <td>{{ user.NOME }}</td>
            <td>{{ user.email }}</td>
            <td>{{ user.cidade }}</td>
            <td>{{ user.estado }}</td>
            <td>{{ user.pais }}</td>
            <td>{{ user.telefone }}</td>
          </tr>
        </tbody>
      </table>
      
    </div>
  </div>
</template>
<style type="text/css">
.table {
  border-collapse: collapse;
  width: 100%;
}
.table td, .table th{
  padding: 10px;
}
.table thead{
  background: #b1adad;
}
.table tr:nth-child(2n) td{
  background: #e1e1e1;
}
</style>
<script>
import { mapState } from 'vuex'
import 'ol/ol.css'
import Feature from 'ol/Feature'
import Map from 'ol/Map'
import Point from 'ol/geom/Point'
import View from 'ol/View'
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text
} from 'ol/style'
import { Cluster, OSM, Vector as VectorSource } from 'ol/source'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { createMD5, exportCSV } from '@/utils/utils'
import { toStringHDMS } from 'ol/coordinate'
import XYZ from 'ol/source/XYZ'
import Overlay from 'ol/Overlay'
import { toLonLat } from 'ol/proj'
export default {
  name: 'FreeMap',
  data () {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      center: { lat: 45.508, lng: -73.587 },
      markers: [],
      places: [],
      currentPlace: null,
      coords: null,
      map: null,
      users: [],
      point: []
    }
  },
  computed: {
    ...mapState('app', ['strings', 'idioma']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 220) + 'px'
    }
  },
  watch: {
    map (val) {
      let map = val
      map.on('click', (evt) => {
        this.point = evt.coordinate
        let [long, lat] = evt.coordinate

        this.axios.post('users/getUsersByLocation', { lat, long }).then(res => {
          this.users = res.data.data
          console.log(res)
        })
      })
    },
    coords (val) {
      this.getCoords(val)
    }

  },
  created () {
    // this.getCoords()
    this.coords = []
  },
  methods: {
    exportar (type = 'csv') {
      let [long, lat] = this.point
      this.axios.post('users/getUsersByLocation', { lat, long, format: type }).then(res => {
        let dados = res.data.data
        if (type === 'csv') {
          exportCSV(dados)
        } else {
          let a = document.createElement("a");
          a.href = "data:application/octet-stream;base64,"+dados;
          a.download = "usuarios.pdf"
          a.click();
        }
        
      })
    },
    async open (us) {
      let res = await this.axios.post('users/get', {
        'limit': 7,
        'offset': 7,
        'vinculado': false,
        'premium': false,
        'premiumVencido': false,
        'consultor': false,
        'pecuarista': false,
        'adm': false,
        'premiumTeste': false,
        'inativo': false,
        'search': us.id,
        'id': us.id
      })
      let user = res.data.data.users[0]
      sessionStorage.setItem('userLoad', JSON.stringify(user))
      setTimeout(() => {
        let tela = window.open('/adm/user/edit', '_blank')
        if (!tela) window.location.href = '/adm/user/edit'
      }, 300)
      console.log({ user })
      return user
    },
    getCoords () {
      console.log({ coords: this.coords })
      const COLOR_VINCULADO = '#3399CC'
      const COLOR_NAO_VINCULADO = '#33cc4c'
      let features = []
      for (let c of this.coords) {
        let p = new Point([c['latitude']], [c['longitude']])
        let f = new Feature({ geometry: p })
        features.push(f)
      }
      var source = new VectorSource({
        features: features
      })
      var clusterSource = new Cluster({
        distance: parseInt(30, 10),
        source: source
      })
      var raster = new TileLayer({
        source: new OSM()
      })
      var styleCache = {}
      var clusters = new VectorLayer({
        source: clusterSource
      })
      if (this.map !== null) {
        this.map.dispose()
      }
      console.log({ clusters })
      this.map = new Map({
        layers: [raster, clusters],
        target: 'map',
        view: new View({
          projection: 'EPSG:4326',
          center: [-44.38, -18.1],
          zoom: 3
        })
      })
      console.log(this.map)
    },
    geolocate () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
      })
    }
  }

}
</script>
